module.exports = __webpack_public_path__ + "img/logo-round.6cb2903c.svg";